var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ibox float-e-margins"},[(_vm.loaded && _vm.user.admin)?_c('div',[_c('modal-form',{attrs:{"add-order":_vm.order}})],1):_vm._e(),_vm._v(" "),_c('order-header'),_vm._v(" "),_c('order-content')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58809ea3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/Pbn/Links/Order.vue
// module id = null
// module chunks = 